import type { ScreenType } from '../types/screens';
import type { LazyScreenLoader } from './shared/RecoverableLazyScreen';

export type LazyScreenType = Exclude<
  ScreenType,
  'main' | 'loading' | 'recovery'
>;

export const lazyScreenLoaders = {
  'camera-access': () => import('./screens/CameraAccessScreen').then((module) => ({ default: module.CameraAccessScreen })),
  'camera-setup': () => import('./screens/CameraSetupScreen').then((module) => ({ default: module.CameraSetupScreen })),
  'desktop-waiting': () => import('./screens/DesktopWaitingScreen').then((module) => ({ default: module.DesktopWaitingScreen })),
  'auto-return': () => import('./screens/AutoReturnScreen').then((module) => ({ default: module.AutoReturnScreen })),
  'emblem-step-up': () => import('./screens/EmblemStepUpScreen').then((module) => ({ default: module.EmblemStepUpScreen })),
  success: () => import('./screens/SuccessScreen').then((module) => ({ default: module.SuccessScreen })),
  failure: () => import('./screens/FailureScreen').then((module) => ({ default: module.FailureScreen })),
  'id-request': () => import('./screens/IdRequestScreen').then((module) => ({ default: module.IdRequestScreen })),
  'id-capture': () => import('./screens/IdCaptureScreen').then((module) => ({ default: module.IdCaptureScreen })),
  'id-review': () => import('./screens/IdReviewScreen').then((module) => ({ default: module.IdReviewScreen })),
  'id-processing': () => import('./screens/IdProcessingScreen').then((module) => ({ default: module.IdProcessingScreen })),
  'selfie-retry': () => import('./screens/SelfieRetryScreen').then((module) => ({ default: module.SelfieRetryScreen })),
  'return-to-desktop': () => import('./screens/ReturnToDesktopScreen').then((module) => ({ default: module.ReturnToDesktopScreen })),
} satisfies Record<LazyScreenType, LazyScreenLoader>;
